<template>
  <div>
    <v-card class="grey lighten-5 shadow-1 pa-3 card-r">
      <v-container fluid class="pa-0">
        <v-layout row wrap class="">
          <!-- <v-flex lg12 sm12 xs12 class="pl-2">
            <div class="text-primary f-15 font-weight-bold left">Filter Question Category</div>
          </v-flex>
          <v-flex lg4 xs6 class="pl-2" v-show="!show">
            <v-select @change="loadTest(selectedType)" solo v-model="selectedType" :items="types" item-value="value" item-text="text" label="Filter Question Category"></v-select>
          </v-flex> -->
          <v-flex lg12 xs12 class="">
            <div class="w-100 right">
              <v-btn light @click="create_test = true"
                     class="sim primary no-shadow card-r "> 
                     <i class="fas fa-plus-circle mr-2"></i>
                     Create Exam</v-btn>
            </div>
          </v-flex>

        </v-layout>
        <v-dialog max-width="1000" class="card-r" v-model="create_test">
            <v-card class="pa-3 card-r grey lighten-4">
              <div class="textColor pa-1 f-30 font-weight-medium"> Create Exam</div>
                <v-layout row wrap>
                    <v-flex xs4 class="pa-1">
                      <v-select
                        solo
                        :items="testTypes"
                        v-model="test.module_type"
                        item-text='text'
                        item-value='value'
                        class="input-group--focused"
                        label="Exam Type"
                        type="text"
                      ></v-select>
                    </v-flex>
                    
                    <v-flex xs4 class="pa-1">
                      <v-select
                        solo
                        :items="lang_type"
                        required
                        v-model="test.lang_type"
                        item-text='text'
                        item-value='value'
                        class="input-group--focused"
                        label="Select Language"
                        type="text"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4 class="pa-1">
                      <v-text-field required v-model="test.no_of_questions" solo label="Number of questions"></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1">
                      <v-text-field required v-model="test.testName"solo label="Exam Name"></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="pa-1">
                      <v-select
                        solo
                        v-model="test.selectedTime"
                        :items="workMin"
                        class="input-group--focused"
                        label="Duration"
                        type="number"
                      ></v-select>
                    </v-flex>
                    <v-flex xs3 class="pa-1">
                      <v-select
                        v-model="test.test_type"
                        solo
                        :items="typs"
                        class="input-group--focused"
                        label="Exam Type"
                        type="number"
                      ></v-select>
                    </v-flex>
                    <v-container fluid class="pa-0" v-if="test.test_type=='manual'">
                        <v-layout row wrap>
                          <v-flex xs12 class="pa-1">
                            <manual @return-selected-questions="setSelectedQuestions"/>
                          </v-flex>
                        </v-layout>
                    </v-container>
                    <v-flex xs12 class="text-xs-right">
                      <v-btn color="primary card-r no-shadow right text-white" v-on:click='saveTest()' dark>ADD Test</v-btn>
                      <v-btn color="grey card-r no-shadow right text-white" @click="create_test = false" dark>Cancel</v-btn>
                    </v-flex>
                </v-layout>
                <v-flex xs12 lg12 class="text-xs-center">
                    <v-progress-circular
                        indeterminate
                        v-if=loading
                        color="primary"
                    ></v-progress-circular>
                    <v-alert
                      :value="true"
                      color="success"
                      icon="check_circle"
                      v-if="alert.type=='success'"
                      solo
                    >
                      {{alert.msg}}
                    </v-alert>
                    <v-alert
                      :value="true"
                      color="error"
                      icon="warning"
                      v-if="alert.type=='warning'"
                      solo
                    >
                      {{alert.msg}}
                    </v-alert>

                    <v-alert
                      :value="true"
                      color="error"
                      icon="warning"
                      v-if="alert.type=='error'"
                      solo
                    >
                      {{alert.msg}}
                    </v-alert>
                </v-flex>
          </v-card>
        </v-dialog>
          <v-layout row wrap>
            <v-flex xs12 lg3 v-for="(n, index) in testsList" class="">
              <!-- <div class="ma-2" v-if="n.category==selectedType || selectedType=='all'"> -->
              <div class="ma-2" >
                <v-card class="pa-2">
                  <v-card-actions class="white pl-0 pr-0">
                    <v-layout row wrap>
                      <v-flex xs6 class="text-xs-left">
                        <div class="f-12 w-break">{{n.module_type}}</div>
                      </v-flex>
                      <v-flex xs6 class="text-xs-right">
                        <div class="f-12 w-break">{{n.question_count}} Questions here</div>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                  <v-img :src="n.image_full_path"
                        :lazy-src="n.image_full_path"
                        aspect-ratio="1" height="150px">
                    <div class="text-xs-right w-100">
                      <v-btn small class="grey" icon @click="deleteTest(n.id)"><v-icon class="f-20 text-white">delete</v-icon></v-btn>
                      <v-btn small class="grey" icon :to="'/edittest/'+n.id"><v-icon class="f-20 text-white">edit</v-icon></v-btn>
                    </div>
                  </v-img>
                  <v-card-title primary-title class="shade-color-transprant">
                    <div class="">
                      <div class="f-15 mb--8 t-shadow text-white w-break">{{n.name}}</div>
                      <span class="f-10 text-grey t-shadow w-break">{{n.duration}} minutes</span>
                    </div>
                  </v-card-title>
                </v-card>
              </div>
            </v-flex>
            <v-dialog v-model="deleted" max-width="290">
              <v-card>
                <v-card-title class="headline">Are you sure want to delete?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="grey text-white" text @click="deleted = false">No</v-btn>
                  <v-btn class="primary" text @click="deleted = false">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
      </v-container>
    </v-card>
  </div>
</template>
<script>
  /*eslint-disable */

  import Manual from './Manual'
  import api from "@/utils/backend-api"
	import { mapState } from 'vuex'

  export default {
    data: () => ({
      deleted:false,
      create_test:false,
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      show: false,
      workMin: [30, 45, 90, 135, 180, 225, 270],
      typs: ['random', 'manual'],
      types: [],  //with 'all' and 'others'
      testTypes:[],  //without 'all' and 'others'
      testListsInfo:[],
      selectedType:'all',
      lang_type:['en','da'],
      test:{
        module_type:'',
        no_of_questions:'',
        testName:'',
        selectedTime:'',
        test_type:'',
        selectedQuestions:[]
      },
    }),
    created:function(){
      let self=this
      this.loadTest();

      api.postData('driver/viewTestCategory')
      .then(res=>{
          let test_type=res.data

          let newtype=[]
          let testType=[]
          let allType={
            text:'all',
            value:'all'
          }
          newtype.push(allType)
          this.test_type=newtype
          for(let x=0;x<test_type.length;x++){
            let type={
              text:test_type[x],
              value:test_type[x]
            }
            newtype.push(type)
            testType.push(type)
          }
          let nullType={
            text:'others',
            value:null
          }
          newtype.push(nullType)
          this.types=newtype
          this.testTypes=testType
      })
    },
    methods:{
      filterExams(selectedType){

      },
      deleteTest(testId){
        let self=this
        this.loading=true
        this.alert.type=''
        this.alert.msg=''
        api.getData('driver/deleteTest/'+testId)
        .then(res=>{
          if(res.status==201){
            self.loading=false
            self.alert.type="success"
            self.alert.msg="Successfully deleted"
            self.create_test=false
            self.loadTest()
          }
        }).catch(err=>{
          self.loading=false
          self.alert.type="warning"
          self.alert.msg="question failed to delete"
        })
      },
      loadTest(category=''){
        api.postData('driver/viewTest',{module_type:category})
        .then(res=>{
            Store.dispatch('setTests', res.data)
            // self.testListsInfo=res.data
        })
      },
      saveTest(){
        let self=this
        this.loading=true
        self.alert.type=""
        this.alert.msg=''
        let Data={
          lang:this.test.lang_type,
          name:this.test.testName,
          category:'demo',
          test_type:this.test.test_type,
          duration:this.test.selectedTime,
          question_count:this.test.test_type=='random'?this.test.no_of_questions:this.selectedQuestions.length,
          questions:this.test.test_type=='random'?'':this.selectedQuestions
        }
        api.postData('driver/createTest',Data)
        .then(res=>{
          self.loadTest()
          if(res.status==201){
            self.loading=false
            self.alert.type="success"
            self.alert.msg="Test successfully created"
            self.create_test=false
            self.show=false
            self.loadTest()
            self.create_test = false
          }
          else{
            self.loading=false
            self.alert.type='error'
            self.alert.msg="Failed to create"
          }
        }).catch(err=>{
          self.loading=false
          self.alert.type="warning"
          self.alert.msg="Failed to create test"
          
        })
      },
      setSelectedQuestions(selectedQuestions){
        this.selectedQuestions=selectedQuestions
      }
    },
    components: {
      Manual
    },
    computed: {
      ...mapState({
        testsList: 'testsList',
      }),
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/pages/exams/Tests.vue